module.exports = __webpack_public_path__ + "static/media/green-check.d50362ed.png";